/* @flow */
const pb = require('./pubsub');
import { NS, LatLng, MarkerCreateProps, Marker, LeafletMouseEvent, CalendarEvent } from './constants';
import { setMdlVal } from './utils';
import marked from '../lib/marked';
import { calendar } from './calendar';
import { UserStorage } from './storage';
const pubSub = pb.setup('markers')
require('./routes').init({
    setMapMode
});

/*::
import L from 'javascriptLibs'
import d3 from 'javascriptLibs'
 */

// this interface is a placeholder to avoid Flow errors when interacting with Leaflet's MapView
interface LeafletView {
    removeLayer: (any) => {};
    _container: any;
}

let userStore = new UserStorage({
    'markers': [],
    'events': []
});

let MARKER_FIX = 4; // fudge factor to avoid bottom of marker getting cut off due to foreginObject rendering quirks

// LEAFLET MARKERS
const markerName = ((document.getElementById('edit-marker-name'): any): HTMLInputElement);
const markerDesc = ((document.getElementById('edit-marker-description'): any): HTMLInputElement);
const markerColr = ((document.getElementById('edit-marker-color'): any): HTMLInputElement);
const markerIcon = ((document.getElementById('edit-marker-icon'): any): HTMLElement);

const tooltip = ((document.getElementById('zoom-tooltip'): any): HTMLElement);
const tooltipTitle = ((document.getElementById('tooltip-title'): any): HTMLElement);
const tooltipInfo = ((document.getElementById('tooltip-info'): any): HTMLElement);

const defaultMarkerIcon = 'help_outline';
const defaultMarkerColor = '#3F4881';
const selectPin = (pin) => {
    document.querySelectorAll('.selected-pin').forEach(p => p.classList.remove('selected-pin'));
    pin.classList.add('selected-pin');
};
const makeIcon = (color=defaultMarkerColor, icon=defaultMarkerIcon) => {
    const contrastColor = (color) => {
        //if only first half of color is defined, repeat it
        if(color.length < 5) {
            color += color.slice(1);
        }
        return (color.replace('#','0x')) > (0xffffff/2).toString() ? '#333' : '#fff';
    }
    const foregroundColor = contrastColor(color);

    const markerStyle = `
        background-color: ${color};
        width: 2em;
        height: 2em;
        display: block;
        left: -1em;
        top: -1em;
        position: relative;
        border-radius: 50% 50% 0;
        transform: translate(0px, 5px) rotate(45deg);
        border: 1px solid ${foregroundColor}
    `;

    const iconStyle = `
        color: ${foregroundColor};
        width: 2em;
        height: 2em;
        text-align: center;
        line-height: 1;
        font-size: 1.5em;
        transform: rotate(-45deg);
        margin-top: -1px;
        margin-left: -1px;
    `;

    return L.divIcon({
        className: "custom-pin",
        iconAnchor: [0, 24],
        labelAnchor: [-6, 0],
        popupAnchor: [0, -36],
        html: `
            <span class="marker-pin" style="${markerStyle}">
              <i class="material-icons" style="${iconStyle}">${icon}</i>
            </span>
        `
    })
};


const analyticsDiv = ((document.getElementById('tooltip-analytics'): any): HTMLElement);
const calendarDiv = ((document.getElementById('tooltip-cal'): any): HTMLElement);
const calendarPane = ((document.getElementById('calendar-pane'): any): HTMLElement);
const reminderPane = ((document.getElementById('reminders-pane'): any): HTMLElement);
const analyticsBtn = ((document.getElementById('analytics'): any): HTMLElement);
const calendarBtn = ((document.getElementById('reminders'): any): HTMLElement);
const mainDescBtn = ((document.getElementById('description'): any): HTMLElement);
let calendarMode = false;
const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
const prettyDate = (date: Date) => {
    return `${months[date.getMonth()]} ${String(date.getDate()).padStart(2, ' ')}`;
}
const expandIntervals = (events: CalendarEvent[], maxDate: Date) => {
    let maxTime = maxDate.getTime();
    let newEvents = [];
    events.forEach(event => {
        let newDate = new Date(event.startDate);
        let index = 0;
        while (newDate.getTime() < maxTime) {

            // @flow-ignore: flow gets confused with spread operator
            newEvents.push({ ...event, date: newDate.getTime() });
            index++;

            if (event.interval === 'weekly') {
                newDate = new Date(event.startDate + 604800000 * index);
            } else if (event.interval === 'biweekly') {
                newDate = new Date(event.startDate + 2 * 604800000 * index);
            } else if (event.interval === 'monthly') {
                newDate = new Date(event.startDate);
                newDate.setMonth(newDate.getMonth() + index);
            } else if (event.interval === 'annual') {
                newDate = new Date(event.startDate);
                newDate.setFullYear(newDate.getFullYear() + index);
            } else {
                return;
            }
        }
    });
    // @flow-ignore: we jsut create newEvents, it's gauranteed to have date property
    return newEvents.sort((a, b) => (a.date < b.date) ? -1 : 1);
}
// marks days with events on the calendar
function markEventDays(events: CalendarEvent[]) {
    Array.from(document.getElementsByClassName('.eventDay')).forEach(element => element.classList.remove('.eventDay'));
    for (let i = 0; i < events.length; i++) {
        // @flow-ignore: date property should be set by the time we call this
        let date = new Date(events[i].date);
        let days = document.getElementsByClassName('currMonth')
        if (date.getMonth() > tooltipCal.Selected.Month) {
            return; // only events from next month left in the list
        } else if (date.getMonth() === tooltipCal.Selected.Month) {
            days[date.getDate() - 1].classList.add('eventDay');
        }
    }
}
// loads calendar events into the event pane
function loadEvents(date?: Date) {
    userStore.filter('events', { marker: selectedMarker.id }).then((markerEvents: CalendarEvent[]) => {
        if (markerEvents.length) {

            // show events from next 3 months in preview
            let threeMonths = new Date();
            threeMonths.setMonth(threeMonths.getMonth() + 3);
            markerEvents = expandIntervals(markerEvents.sort((a, b) => (a.startDate < b.startDate) ? -1 : 1), threeMonths);

            markEventDays(markerEvents);

            let title: string;
            if (date) {
                markerEvents = markerEvents.filter(e => e.date === date.getTime());
                title = prettyDate(date);
            } else {
                title = 'Upcoming Events';
            }

            // but only the first 10 events
            reminderPane.innerHTML = `<div class="reminder-title">${title}</div>`;
            markerEvents.slice(0, 10).forEach(event => {
                // @flow-ignore: date should be set by expandIntervals
                let date = new Date(event.date);
                let expand = `() => {
                    let expanded = document.getElementById('reminder-expanded');
                    expanded && expanded.removeAttribute('id');
                    this.parentElement.setAttribute('id', 'reminder-expanded');
                }`;
                let eventHtml = `<div class="reminder-wrapper">
                    <pre class="reminder-date">${prettyDate(date)}</pre>
                    <div class="reminder-name" onclick="(${expand})()">${event.name}</div>
                    <div class="reminder-expandable markdown">
                        ${event.content ? marked(event.content) : ''}
                        <i class="material-icons reminder-open" onclick="window.editEvent('${event.id}')">create</i>
                    </div>
                </div>`;
                reminderPane.innerHTML += eventHtml;
            });
        } else {
            reminderPane.innerText = 'No reminders set. Click "Edit" to create new reminders/events for this marker.';
        }
    });
}
const tooltipCal = calendar(calendarPane, [], {
    EventTargetWholeDay: true,
    onSelect: (date: Date) => {
        date.setHours(0, 0, 0, 0);
        loadEvents(date);
    }
});
analyticsBtn.onclick = function (e) {
    calendarMode = false;
    analyticsDiv.style.display = 'block';
    calendarDiv.style.display = 'none';
    tooltipInfo.style.display = 'none';
    eventQty.style.display = '';

    mainDescBtn.style.display = 'inline';
    analyticsBtn.style.display = 'none';
    calendarBtn.style.display = 'inline';
    loadEvents();
}
calendarBtn.onclick = function (e) {
    calendarMode = true;
    calendarDiv.style.display = 'block';
    analyticsDiv.style.display = 'none';
    tooltipInfo.style.display = 'none';
    eventQty.style.display = 'none';

    mainDescBtn.style.display = 'inline';
    calendarBtn.style.display = 'none';
    analyticsBtn.style.display = 'inline';
    loadEvents();
}
function resetTooltipCalendar() {
    calendarMode = false;
    analyticsDiv.style.display= 'none';
    calendarDiv.style.display = 'none';
    tooltipInfo.style.display = 'block';
    eventQty.style.display = '';

    mainDescBtn.style.display = 'none';
    analyticsBtn.style.display = 'inline';
    calendarBtn.style.display = 'inline';
}
mainDescBtn.onclick = resetTooltipCalendar;

// modes: zoom, marker
let markerMode = 'move';
// changes current mode (how user events are handled)
function setMapMode(mode) {
    markerMode = mode;
    if (mode === 'move') {
        L.DomUtil.removeClass(mapView._container, 'crosshair-cursor-enabled');
    } else {
        const info = {
            'marker': "Mark a point of interest",
            'route': "Measure distance / route between two points"
        }
        L.DomUtil.addClass(mapView._container, 'crosshair-cursor-enabled');
        window.showTooltip({}, { title: info[mode] }, false);
    }
}
pubSub.subscribe('marker:mode', setMapMode);
function getMode() {
    return markerMode;
}
const addLocation = ((document.getElementById('add-location'): any): HTMLElement);
// addLocation.addEventListener('click', () => setMapMode('marker'));

// create a new tentative marker (don't save to server yet)
let selectedMarkerIcon;
function createTentativeMarker(e: MarkerCreateProps, name?: string) {
    setMapMode('move');
    selectedMarker = {
        id: null,
        name: 'New Marker' + (name ? ` (${name})` : ''),
        latLng: e.latlng,
        color: defaultMarkerColor,
        zip: e.zip,
        icon: defaultMarkerIcon
    };
    document.querySelectorAll('.selected-pin').forEach(p => p.classList.remove('selected-pin')); // deselect old marker
    userStore.append('markers', selectedMarker, true).then(id => {
        leafletMarkers[id] = L.marker(e.latlng, {
            icon: makeIcon()
        }).addTo(mapView).on('click', handleMarkerClick).on('mouseover', hoverOverMarker).on('mouseout', () => {
            markerLabel.style.display = "";
        });
        selectMarker(e, !name); // having a tentative name implies the marker was auto-generated via search result
    });
}
pubSub.subscribe('measure:finish', () => {
    setMapMode('move');
    window.hideTooltip();
    // pubSub.publish('tooltip:hide')
});
pubSub.subscribe('measure:start', () => {
    setMapMode('route');
    // ui.hideTooltip();
});

// load existing marker data
let leafletMarkers = {};
function loadMarkerLeaflet(marker: Marker) {
    selectedMarkerIcon = L.marker([marker.latLng.lat, marker.latLng.lng], {
        icon: makeIcon(marker.color, marker.icon)
    }).addTo(mapView).on('click', handleMarkerClick).on('mouseover', hoverOverMarker).on('mouseout', () => {
        markerLabel.style.display = "";
    });
    leafletMarkers[marker.id] = selectedMarkerIcon;
}

const markerSize = 15;
let markerLayer;
let d3Markers = null;
function loadMarkersD3(projection: d3.Projection) {
    // TODO: a bit of a hack for now, will disengage from leaflet eventually
    const svg = d3.select('#main-svg');
    if (!markerLayer) {
        markerLayer = svg.append('g').attr('class', 'markers').style('display', 'none');
        window.mmm = markerLayer
        window.sss = svg
    }
    // const markerLayer = svg.select("g.markers").data([1]).enter().append('g').attr('class', 'markers');
    userStore.get('markers').then((markers: Marker[]) => {
        markerLayer.selectAll('.marker-pin')
            .data(markers)
            .enter()
            .append((d: Marker) => {
                const icon = makeIcon(d.color, d.icon);
                const element = document.createElement("div");
                element.className = "d3-marker";
                element.style.fontSize = `${markerSize/2}px`;
                element.innerHTML = icon.options.html;
                element.style.transform = `translate(${markerSize}px, ${markerSize}px)`;
                const wrapper = document.createElementNS(NS, 'foreignObject');
                wrapper.append(element);
                return wrapper;
            })
            .attr('x', d => projection([d.latLng.lng, d.latLng.lat])[0] - markerSize)
            .attr('y', d => projection([d.latLng.lng, d.latLng.lat])[1] - markerSize * 2)
            .attr('width', markerSize * 2)
            .attr('height', markerSize * 2 + MARKER_FIX)
            .on('mouseover', function(d) {
                window.showTooltip(this, { title: d.name, text: d.content })
                showOverlappingMarkers(d, projection);
            })
            .on('mouseout', window.hideTooltip)
            .on('click', window.zoomToMarker)
            .exit().remove();
        
            toggle()
    });
}

function moveMarkers(projection) {
    markerLayer.selectAll('.marker-pin')
        .data(markers)
        .enter()
        .append((d: Marker) => {
            const icon = makeIcon(d.color, d.icon);
            const element = document.createElement("div");
            element.className = "d3-marker";
            element.style.fontSize = `${markerSize/2}px`;
            element.innerHTML = icon.options.html;
            element.style.transform = `translate(${markerSize}px, ${markerSize}px)`;
            const wrapper = document.createElementNS(NS, 'foreignObject');
            wrapper.append(element);
            return wrapper;
        })
        .attr('x', d => projection([d.latLng.lng, d.latLng.lat])[0] - markerSize)
        .attr('y', d => projection([d.latLng.lng, d.latLng.lat])[1] - markerSize * 2)
        .attr('width', markerSize * 2)
        .attr('height', markerSize * 2 + MARKER_FIX)
        .on('mouseover', function(d) {
            window.showTooltip(this, { title: d.name, text: d.content })
            showOverlappingMarkers(d, projection);
        })
        .on('mouseout', window.hideTooltip)
        .on('click', window.zoomToMarker)
        .exit().remove();
}

const toggleMarkers = ((document.getElementById('toggle-markers'): any): HTMLInputElement);
function toggle() {
    if (toggleMarkers && toggleMarkers.checked) {
        markerLayer.style('display', '');
        addLocation.style.display = "block";
    } else {
        hide();
    }
}
// toggleMarkers.onclick = toggle;
pubSub.subscribe('zoom:map', (item) => {
    // toggleMarkers.click();
});
function hide() {
    markerLayer.style('display', 'none');
    // addLocation.style.display = "none";
}
// show markers hidden behind current one
function showOverlappingMarkers(marker: Marker, projection) {
    let markersBehindCurrent = [];
    let epsilon = 0.5; // pixels
    userStore.get('markers').then(markers => {
        markerLayer.selectAll('.marker-pin').data(markers).each((d: Marker) => {
            if (
                Math.abs(parseFloat(d.latLng.lat) - parseFloat(marker.latLng.lat)) < epsilon && 
                Math.abs(parseFloat(d.latLng.lng) - parseFloat(marker.latLng.lng)) < epsilon
            ) {
                markersBehindCurrent.push(d);
            }
        });
        markerLayer.select('.hover-over-pin').remove(); // remove existing hovered markers if mouseout failed to do so
        let container = markerLayer.selectAll('.hover-over-pin').data([1]).enter().append(() => {
            const wrapper = document.createElementNS(NS, 'foreignObject');
            markersBehindCurrent.forEach((m: Marker, i: number) => {
                const icon = makeIcon(m.color, m.icon);
                const element = document.createElement("div");
                element.className = "d3-marker";
                element.style.fontSize = `${markerSize/2}px`;
                element.innerHTML = icon.options.html;
                // element.style.transform = `translate(${markerSize + markerSize * i}px, ${markerSize}px)`;
                element.style.position = "absolute";
                element.style.top = "15px";
                element.style.left = `${markerSize * (markersBehindCurrent.length - i)}px`;
                element.onmouseover = function() {
                    element.classList.add('d3-selected-pin');
                    window.showTooltip(wrapper, { title: `${m.name} (${m.zip})`, text: m.content })
                };
                element.onmouseout = function() {
                    element.classList.remove('d3-selected-pin');
                }
                element.onclick = () => window.zoomToMarker(m);
                wrapper.append(element);
            });
            return wrapper;
        })
        .on('mouseout', function(e) {
            window.hideTooltip();
            let box = this.getBoundingClientRect();
            const x = e.clientX, y = e.clientY;
            if ((x < box.x || box.x + box.width < x) || (y < box.y || box.y + box.height < y)) {
                // destroy layer once mouse moves outside the region
                markerLayer.select('.hover-over-pin').remove();
            }
        })
        .attr('class', 'hover-over-pin')
        .attr('x', d => projection([marker.latLng.lng, marker.latLng.lat])[0] - markerSize)
        .attr('y', d => projection([marker.latLng.lng, marker.latLng.lat])[1] - markerSize * 2)
        .attr('width', markerSize + markerSize * markersBehindCurrent.length + 4 /* hack/pad to detect unhover better */)
        .attr('height', markerSize * 2 + MARKER_FIX);
    })
}

// function for cleaning up markers (leaflet)
function cleanupMarkers() {
    Object.values(leafletMarkers).forEach(marker => {
        mapView.removeLayer(marker);
    });
}

// hover over marker that's already rendered (show tooltip)
let markerLabel = ((document.getElementById('marker-tooltip'): any): HTMLElement);
function hoverOverMarker(e: LeafletMouseEvent) {
    userStore.find('markers', {
        latLng: e.latlng
    }).then((r: Marker) => {
        markerLabel.innerHTML = r.name;
        markerLabel.style.display = "block";
        markerLabel.style.left = (e.containerPoint.x - markerLabel.offsetWidth/2) + "px";
        markerLabel.style.top = e.containerPoint.y + "px";
    })
}

// select marker that's already rendered
let selectedMarker;
function selectMarker(e: MarkerCreateProps | LeafletMouseEvent, publishEvent = true) {
    return userStore.find('markers', {
        latLng: e.latlng
    }).then((r: Marker) => {
        if (!r) {
            throw Error('Marker not found');
        } else {
            console.log(leafletMarkers[r.id])
            selectPin(leafletMarkers[r.id]._icon);
            selectedMarkerIcon = leafletMarkers[r.id];
            selectedMarker = r;
            if (publishEvent) {
                // sometimes we don't want to publish the event, i.e. if it renames a search result
                pubSub.publish('location:load', {
                    type: 'marker',
                    obj: r
                });
            }
            showMarkerTooltip(r);
        }
    });
}
function handleMarkerClick(e: LeafletMouseEvent) {
    if (getMode() === 'route') {
        pubSub.publish('measure:startMarker', e);
    } else {
        selectMarker(e);
    }
}

// tooltip for showing/editing marker (leaflet) data
let stateTooltip = ((document.getElementById('state-tooltip'): any): HTMLElement);
let markerControls = ((document.getElementById('marker-controls'): any): HTMLElement);
let eventQty = ((document.getElementById('reminders-qty'): any): HTMLElement);
let eventTooltip = ((document.getElementById('reminders-tip'): any): HTMLElement);
function showMarkerTooltip(marker: Marker) {
    resetTooltipCalendar(); // if calendar was previously opened
    tooltipTitle.innerHTML = marker.name;
    let content = marker.content ? marked(marker.content) : 'Placeholder marker, edit it using the buttons below.';
    tooltipInfo.innerHTML = content;
    stateTooltip.style.display = "none";
    markerControls.style.display = "block";
    userStore.filter('events', { marker: marker.id }).then((e: CalendarEvent[]) => {
        eventQty.innerText = e.length
        eventTooltip.innerText = `${e.length} Reminders`
    })

    // position marker in top-right
    tooltip.style.width = "300px";
    tooltip.style.left = "";
    tooltip.style.bottom = "";

    tooltip.style.top = "10px";
    tooltip.style.right = "10px";
    tooltip.style.display = "block";
}
pubSub.subscribe('zoom:reset', () => tooltip.style.display = "none");

// EVENT CREATE/UPDATE LOGIC
let selectedEvent = null;
const eventDialog = ((document.getElementById('event-edit'): any): HTMLDialogElement);
const eventDeleteDialog = ((document.getElementById('event-delete'): any): HTMLDialogElement);
const eventName = ((document.getElementById('edit-event-name'): any): HTMLInputElement);
const eventDate = ((document.getElementById('edit-event-date'): any): HTMLInputElement);
const eventCalr = ((document.getElementById('edit-event-cal'): any): HTMLElement);
const eventDesc = ((document.getElementById('edit-event-description'): any): HTMLInputElement);
const eventRepeat = ((document.getElementById('edit-event-repeats'): any): HTMLInputElement);
const eventRemind = ((document.getElementById('edit-event-remind'): any): HTMLInputElement);
function humanDate(d) {
    return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
}
// spawn create event dialog
function createEvent() {
    // @flow-ignore: TODO; can we ensure that id will not be null at this point?
    eventDialog.setAttribute('data-marker', selectedMarker.id);
    eventDialog.removeAttribute('data-event');
    setMdlVal(eventName, '');
    setMdlVal(eventDesc,  '');
    setMdlVal(eventDate,  '');
    setMdlVal(eventRepeat, 'no');
    setMdlVal(eventRemind, 'silent');
    calendar(eventCalr, [], {
        minDate: new Date(),
        onSelect: (d) => {
            setMdlVal(eventDate,  humanDate(d));
        }
    });
    eventDialog.showModal();
}
// spawn edit event dialog
function editEvent(eventId: string) {
    // @flow-ignore: TODO; can we ensure that id will not be null at this point?
    eventDialog.setAttribute('data-marker', selectedMarker.id);
    eventDialog.setAttribute('data-event', eventId);
    userStore.find('events', { id: eventId }).then((e: CalendarEvent) => {
        setMdlVal(eventName,  e.name);
        setMdlVal(eventDesc,  e.content);
        setMdlVal(eventDate,  humanDate(new Date(e.startDate)));
        setMdlVal(eventRepeat, e.interval);
        setMdlVal(eventRemind, e.reminder);
    });
    calendar(eventCalr, [], {
        minDate: new Date(),
        onSelect: (d) => {
            setMdlVal(eventDate,  humanDate(d));
        }
    });
    eventDialog.showModal();
}

// save event creation/update
function saveEvent() {
    const markerId = eventDialog.getAttribute('data-marker');
    const eventId = eventDialog.getAttribute('data-event');
    const reminderValue = eventRemind.value;
    if (reminderValue === 'browser') {
        // we'll need them in the future
        Notification.requestPermission();
    }
    let newEvent = {
        name: eventName.value,
        content: eventDesc.value,
        marker: markerId,
        startDate: new Date(eventDate.value).getTime(),
        interval: eventRepeat.value,
        reminder: reminderValue,
    };
    if (eventId) {
        // updating existing event
        userStore.edit('events', { id: eventId }, newEvent).then(id => {
            loadEvents();
        });
    } else {
        // creating new event
        userStore.append('events', newEvent).then(id => {
            loadEvents();
        })
    }
    eventDialog.close();
}
((document.getElementById('save-event'): any): HTMLElement).addEventListener('click', () => saveEvent());

// show confirmation eventDialog for event deletion
function confirmDeleteEvent() {
    let id = eventDialog.getAttribute('data-event');
    // @flow-ignore: id should be set by editEvent
    eventDeleteDialog.setAttribute('data-event', id);
    eventDeleteDialog.showModal();
    eventDialog.close();
}
((document.getElementById('delete-event'): any): HTMLElement).addEventListener('click', () => confirmDeleteEvent());

// delete event
function deleteEvent() {
    let id = eventDialog.getAttribute('data-event');
    userStore.remove('events', id);
    eventDeleteDialog.close();
}
((document.getElementById('delete-event-confirm'): any): HTMLElement).addEventListener('click', () => deleteEvent());

// DIALOG CREATE/UPDATE LOGIC
const markerDialog = ((document.getElementById('marker-edit'): any): HTMLDialogElement);
const markerDeleteDialog = ((document.getElementById('marker-delete'): any): HTMLDialogElement);

function editMarker() {
    // @flow-ignore: TODO; can we ensure that id will not be null at this point?
    markerDialog.setAttribute('data-marker', selectedMarker.id);
    setMdlVal(markerName,  selectedMarker.name);
    setMdlVal(markerDesc,  selectedMarker.content || '');
    markerIcon.innerHTML = selectedMarker.icon;
    markerColr.value = selectedMarker.color.slice(1);
    markerColr.style.backgroundColor = '#' + markerColr.value;
    markerDialog.showModal();
}
((document.getElementById('create'): any): HTMLElement).addEventListener('click', () => {
    if (calendarMode) {
        createEvent();
    } else {
        editMarker();
    }
});

// icon selection for marker
const markerIconSelect = ((document.getElementById('edit-marker-icon-select'): any): HTMLElement);
markerIcon.onclick = () => { markerIconSelect.style.display = "block" };
Array.from(markerIconSelect.children).forEach(child => {
    child.onclick = () => {
        markerIcon.innerHTML = child.innerHTML;
        markerIconSelect.style.display = "";
    };
});

function saveMarker() {
    // @flow-ignore: this attribute should always be set when this is called
    let origId: string = markerDialog.getAttribute('data-marker');
    let newMarker = {
        name: markerName.value,
        content: markerDesc.value,
        color: '#' + markerColr.value,
        icon: markerIcon.innerHTML
    };
    userStore.edit('markers', { id: origId }, newMarker).then(id => {
        // id update happens when cache is written to disk
        if (id !== 0) {
            leafletMarkers[id] = leafletMarkers[origId];
            delete leafletMarkers[origId];
        }
        userStore.find('markers', { id: id }).then((r: Marker) => showMarkerTooltip(r));
    });
    markerDialog.close();
    selectedMarkerIcon.setIcon(makeIcon(newMarker.color, newMarker.icon));
}
((document.getElementById('save-marker'): any): HTMLElement).addEventListener('click', () => saveMarker());

// show confirmation dialog for marker deletion
function confirmDeleteMarker() {
    // @flow-ignore: TODO: fix, id is returned later after the rest of the data, this is a hack since id is given by backend, refactor
    markerDeleteDialog.setAttribute('data-marker', selectedMarker.id);
    markerDeleteDialog.showModal();
    markerDialog.close();
}
((document.getElementById('delete-marker'): any): HTMLElement).addEventListener('click', () => confirmDeleteMarker());

// delete marker
function deleteMarker() {
    let id = markerDialog.getAttribute('data-marker');
    userStore.remove('markers', id);
    mapView.removeLayer(selectedMarkerIcon);
    delete leafletMarkers[id || 0];
    markerDeleteDialog.close();
    tooltip.style.display = "";
}
((document.getElementById('delete-marker-confirm'): any): HTMLElement).addEventListener('click', () => deleteMarker());

function createOrSelectMarker(latlng: LatLng, zip: string, tentativeName?: string) {
    selectMarker({ latlng, zip }).catch(() => {
        createTentativeMarker({ latlng, zip }, tentativeName);
    });
}

function fetch() {
    return userStore.get('markers');
}

// TODO: rewrite
// @flow-ignore: rewrite this hack later to instantiate markers as a class
let mapView: LeafletView = null;
function setMapView(view: LeafletView) {
    mapView = view;
}

export default {
    hide,
    toggle,
    setMapView,
    fetch,
    getMode,
    cleanupMarkers,
    loadMarkersD3,
    loadMarkerLeaflet,
    createMarker: createTentativeMarker,
    editEvent,
    createOrSelectMarker,
    resetTooltipCalendar
};
